import React from 'react'
import PropTypes from 'prop-types'
import { Layout, SEO, SliceZone, NewsList } from 'components'
import StyledPageHeader from 'components/StyledPageHeader/index.css'
import styled from 'styled-components'
import { graphql } from 'gatsby'

const StyledSlices = styled.div``

function Page({ data: { prismicPage } }) {
  const {
    data: { page_title, meta_title, meta_description, meta_images, body },
    uid,
  } = prismicPage

  return (
    <Layout>
      <SEO title={meta_title} desc={meta_description} images={meta_images} />
      {page_title && page_title.text && (
        <StyledPageHeader>
          <h1>{page_title.text}</h1>
        </StyledPageHeader>
      )}
      {uid === 'news' && <NewsList />}
      {body !== null && (
        <StyledSlices>
          <SliceZone allSlices={body} />
        </StyledSlices>
      )}
    </Layout>
  )
}

export default Page

Page.defaultProps = {}

Page.propTypes = {
  data: PropTypes.shape({
    prismicPage: PropTypes.shape({
      data: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
}

export const pageQuery = graphql`
  query($uid: String!) {
    prismicPage(uid: { eq: $uid }) {
      id
      uid
      data {
        meta_title
        meta_description
        meta_images {
          image {
            url
            dimensions {
              width
              height
            }
          }
        }
        page_title {
          text
        }

        body {
          ... on PrismicPageBodyParagraph {
            slice_type
            id
            primary {
              content {
                html
              }
            }
          }

          ... on PrismicPageBodyGlobalSection {
            id
            slice_type
            primary {
              content {
                html
              }
              content_reference {
                id
                type
                document {
                  ... on PrismicClientList {
                    data {
                      logos {
                        logo {
                          alt
                          copyright
                          url
                        }
                        link {
                          link_type
                          url
                          target
                        }
                      }
                    }
                  }
                  ... on PrismicNewsletterSignup {
                    data {
                      input_placeholder
                      submit_button_text
                      success_message
                      error_message
                      exists_message
                      retry_link_text
                      consent_checkbox_content {
                        html
                      }
                    }
                  }
                }
              }
            }
          }

          ... on PrismicPageBodyParagraphImage {
            slice_type
            id
            primary {
              content {
                html
              }
              paragraph_title {
                html
              }
              image_position
              image {
                alt
                localFile {
                  childImageSharp {
                    fixed(width: 200, height: 200, quality: 100) {
                      ...GatsbyImageSharpFixed
                    }
                  }
                }
              }
            }
          }

          ... on PrismicPageBodyParagraphGrid {
            slice_type
            id
            primary {
              row_items
            }
            items {
              content {
                html
              }
            }
          }
        }
      }
    }
  }
`
